(function($) {

	'use strict';

	var init = function() {

		showJoinUs();

		$(window).resize(function() {
			if($(window).width() > 767) {
				stickToFooter();
			}
		}).resize()

	};

	var showJoinUs = function() {

		$('.join-us__trigger').click(function() {
			$('.join-us').toggleClass('active');
		});
		$('.join-us__trigger').hover(function() {
			if($(window).outerWidth() > 991) {
				$('.join-us').toggleClass('over');
			}
		});
	}

	var stickToFooter = function() {

		$(window).scroll(function() {

			var windowScroll = $(window).scrollTop();

			var footerOffset = $('footer').offset().top;

			var windowHeight = $(window).height();

			if(windowScroll >= footerOffset - windowHeight) {
				$('.join-us').addClass('stickToFooter');
			} else {
				$('.join-us').removeClass('stickToFooter');
			}
		});
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
